import { proctorTypeLabelMap } from '@exam-center/exam-event-management';
import { ExamCenterProctorRequestStep, ExamCenterProctorRequestType } from '@exam-center/graphql';
import { type ProctorRequestStatusLabelVariant } from '@exam-center/proctor-management';

export const ALLOW_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

export const PROCTOR_REQUEST_STATUS_LABEL_MAP: Record<
  ExamCenterProctorRequestStep,
  ProctorRequestStatusLabelVariant
> = {
  [ExamCenterProctorRequestStep.Draft]: 'draft',
  [ExamCenterProctorRequestStep.InReview_1]: 'in-review',
  [ExamCenterProctorRequestStep.InReview_2]: 'in-review',
  [ExamCenterProctorRequestStep.Rejected]: 'rejected',
  [ExamCenterProctorRequestStep.Approved]: 'approved',
};

export const PROCTOR_REQUEST_TYPE_OPTIONS = [
  {
    value: ExamCenterProctorRequestType.Proctor_1,
    label: proctorTypeLabelMap[ExamCenterProctorRequestType.Proctor_1],
  },
  {
    value: ExamCenterProctorRequestType.Proctor_2,
    label: proctorTypeLabelMap[ExamCenterProctorRequestType.Proctor_2],
  },
];

export const EXAM_CENTER_PROCTOR_REQUEST_ERROR_CODE_TO_FORM_ERROR = {
  INVALID_CITIZEN_CARD_NUMBER: {
    fieldName: 'personal.idNumber',
    message: 'รูปแบบเลขบัตรประชาชนไม่ถูกต้อง ต้องมีจำนวน 13 หลักและเป็นตัวเลขเท่านั้น',
  },
  EXAM_CENTER_PROCTOR_BY_ID_CARD_ALREADY_EXISTS: {
    fieldName: 'personal.idNumber',
    message: 'เลขบัตรประชาชนนี้มีอยู่ในระบบแล้ว กรุณาตรวจสอบหรือใช้หมายเลขบัตรประชาชนอื่น',
  },
  EXAM_CENTER_PROCTOR_REQUEST_BY_ID_CARD_IS_IN_REVIEW: {
    fieldName: 'personal.idNumber',
    message: 'เลขบัตรประชาชนนี้อยู่ระหว่างการยื่นคำขออนุมัติ กรุณาตรวจสอบ',
  },
  EXAM_CENTER_PROCTOR_REQUEST_BY_ID_CARD_IS_REJECTED: {
    fieldName: 'personal.idNumber',
    message: 'เลขบัตรประชาชนนี้อยู่ในคำขอที่ไม่อนุมัติ กรุณาตรวจสอบ',
  },
  EXAM_CENTER_PROCTOR_REQUEST_BY_EMAIL_IS_IN_REVIEW: {
    fieldName: 'personal.email',
    message: 'อีเมลนี้อยู่ระหว่างการยื่นคำขออนุมัติ กรุณาตรวจสอบหรือใช้ที่อยู่อีเมลอื่น',
  },
  EXAM_CENTER_PROCTOR_BY_EMAIL_ALREADY_EXISTS: {
    fieldName: 'personal.email',
    message: 'อีเมลนี้มีอยู่ในระบบแล้ว กรุณาตรวจสอบหรือใช้ที่อยู่อีเมลอื่น',
  },
} as const;
